// src/enduser/PubHeader.jsx
// 公開：「戻る」リンクとタイトルのある紺のヘッダー（審査員・リング・グループの各画面で共通）
import React from "react";
import { Link } from "react-router-dom";

export default function PubHeader({ to, backLabel, title }) {
  return (
    <header className="pubCatHdr">
      <div className="pubCatBrand">
        <Link to="/top" className="pubCatBrandLink">DOG SHOW CATALOGUE</Link>
      </div>
      <div className="pubCatInner">
        <Link to={to} className="pubCatBack">
          <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C8A35A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 6l-6 6 6 6" />
          </svg>
          <span>{backLabel}</span>
        </Link>
        <div className="pubCatHdrTitle">{title}</div>
        <span className="pubCatHdrPad" />
      </div>
    </header>
  );
}
